/**
 * environment variables
 */
export const envSetting = {
  apiPassword: import.meta.env.VITE_API_AUTH_PASSWORD,
  apiUser: import.meta.env.VITE_API_AUTH_USER,
  assistantsAppUniqueCode: import.meta.env.VITE_ASSISTANTS_APP_UNIQUE_CODE,
  avatarSize: import.meta.env.VITE_MAX_AVATAR_SIZE,
  baseCountry: import.meta.env.VITE_BASE_COUNTRY,
  baseCurrency: import.meta.env.VITE_BASE_CURRENCY,
  bgLogoCompany: import.meta.env.VITE_BG_MAIN_LOGO_COMPANY,
  bgLogoWisenroll: import.meta.env.VITE_BG_MAIN_LOGO_WISENROLL,
  companyName: import.meta.env.VITE_COMPANY_NAME,
  companyPage: import.meta.env.VITE_COMPANY_PAGE,
  cryptoAesPassword: import.meta.env.VITE_CRYPTO_AES_PASSWORD,
  eighth: import.meta.env.VITE_COLOR_EIGHTH,
  expirationTime: import.meta.env.VITE_EXPIRATION_TIME,
  fifth: import.meta.env.VITE_COLOR_FIFTH,
  fifthHover: import.meta.env.VITE_COLOR_FIFTH_HOVER,
  fileSize: import.meta.env.VITE_MAX_FILE_SIZE,
  first: import.meta.env.VITE_COLOR_FIRST,
  firstHover: import.meta.env.VITE_COLOR_FIRST_HOVER,
  fourth: import.meta.env.VITE_COLOR_FOURTH,
  fourthHover: import.meta.env.VITE_COLOR_FOURTH_HOVER,
  general: import.meta.env.VITE_COLOR,
  generalHover: import.meta.env.VITE_COLOR_HOVER,
  googleAutocompleteApiKey: import.meta.env.REACT_GOOGLE_AUTOCOMPLETE_API_KEY,
  logoAdsWisenroll: import.meta.env.VITE_ADS_LOGO_WISENROLL,
  maxMinutesToken: import.meta.env.VITE_MAX_LENGTH_TOKEN,
  maxTotalFilesSize: import.meta.env.VITE_MAX_TOTAL_FILES_SIZE,
  minutesRefreshApplication: import.meta.env.VITE_MINUTES_REFRESH_APPLICATIONS,
  minutesToken: import.meta.env.VITE_MINUTES_TOKEN,
  routeBnfaffiliates: import.meta.env.VITE_ROUTE_BNFAFFILIATES,
  routeCreateAccount: import.meta.env.VITE_CREATE_ACCOUNT,
  routeCrediroll: import.meta.env.VITE_ROUTE_CREDIROLL,
  routeGenieWizz: import.meta.env.VITE_ROUTE_GENIE_WIZZ,
  routeOnlineBankAccount: import.meta.env.VITE_ROUTE_ONLINE_BANK_ACCOUNT,
  routePalMerchant: import.meta.env.VITE_ROUTE_PALMERCHANT,
  routeTurboAhorro: import.meta.env.VITE_ROUTE_TURBO_AHORRO,
  routeWisenroll: import.meta.env.VITE_ROUTE_WISENROLL,
  second: import.meta.env.VITE_COLOR_SECOND,
  secondHover: import.meta.env.VITE_COLOR_SECOND_HOVER,
  seventh: import.meta.env.VITE_COLOR_SEVENTH,
  seventhHover: import.meta.env.VITE_COLOR_SEVENTH_HOVER,
  sixth: import.meta.env.VITE_COLOR_SIXTH,
  sixthHover: import.meta.env.VITE_COLOR_SIXTH_HOVER,
  termsConditionsEn: import.meta.env.VITE_TERMS_CONDITIONS_EN,
  termsConditionsEs: import.meta.env.VITE_TERMS_CONDITIONS_ES,
  third: import.meta.env.VITE_COLOR_THIRD,
  thirdHover: import.meta.env.VITE_COLOR_THIRD_HOVER,
  videoSize: import.meta.env.VITE_MAX_VIDEO_SIZE,
  wisenrollApi: import.meta.env.VITE_WISENROLL_API_BASE_URL,
  showUploadFromFiles: import.meta.env.VITE_ENABLE_BUTTON_UPLOAD_FILE,
  defaultLanguage: import.meta.env.VITE_DEFAULT_LANGUAGE,
  isDebugErrorBoundary: import.meta.env.VITE_DEBUG_ERROR_BOUNDARY,
  isLendency: import.meta.env.VITE_IS_LENDENCY,
  isBlockedSelectNationality: import.meta.env.VITE_DISABLE_SELECT_NATIONALITY,
  conditionalStates: import.meta.env.VITE_CONDITIONAL_STATES,
  listAllAssistants: import.meta.env.VITE_LIST_ALL_ASSISTANTS,
  isErudaEnabled: import.meta.env.VITE_IS_ERUDA_ENABLED,
  isDev: import.meta.env.NODE_ENV === 'development'
};